import { makeApiCall } from "../makeApiCall";
import { AdminService_URL } from "../Url";

export const markOrderActions = {
  FETCH_ORDER_DATA_SUCCESS: "FETCH_ORDER_DATA_SUCCESS",
  FETCH_ORDER_DATA_ERROR: "FETCH_ORDER_DATA_ERROR",
};

// Generate CSV

export function markOrderDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: markOrderActions.FETCH_ORDER_DATA_SUCCESS,
      payload: props,
    });
  };
}

export function markOrderDetailsError(error) {
  return {
    type: markOrderActions.FETCH_ORDER_DATA_ERROR,
    payload: error,
  };
}

export function markOrderDetailsThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const getUrl = `${AdminService_URL}/getOrderDetailForCheckerPwa?orderId=${props.orderId}`;
  return makeApiCall(
    getUrl,
    markOrderDetailsSuccess,
    markOrderDetailsError,
    "GET",
    null,
    reqHeader,
    props.history
  );
}
